import { LocalizedSubsectionTitle } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SimpleList, SimpleListItem, Stack, Typography, WithChildren } from '@optimus-web/core';
import { SimpleAmount } from '@mews-commander/data-access';
import { localizeCurrencyValue } from '@mews-commander/utils';

interface BrandRegistrationDescriptionProps {
    brandRegistrationCost: SimpleAmount;
    campaignRegistrationCost: SimpleAmount;
}

export const BrandRegistrationDescription = ({
    brandRegistrationCost,
    campaignRegistrationCost,
}: BrandRegistrationDescriptionProps) => {
    const brandRegistrationCostText = localizeCurrencyValue({
        value: brandRegistrationCost.value,
        currency: brandRegistrationCost.currencyCode,
    });

    const campaignRegistrationCostText = localizeCurrencyValue({
        value: campaignRegistrationCost.value,
        currency: campaignRegistrationCost.currencyCode,
    });

    return (
        <Stack vertical spacing="200">
            <LocalizedSubsectionTitle textKey={TextKey.RegistrationInfo} />
            <SimpleList spacing="300">
                <ListItem>
                    <LocalizedText textKey={TextKey.SmsUsaBrandRegistrationTriggersCampaignRegistration} />
                </ListItem>
                <ListItem>
                    <LocalizedText textKey={TextKey.SmsUsaRegistrationReferToThisPage} />
                </ListItem>
                <ListItem>
                    <LocalizedText textKey={TextKey.SmsUsaBrandRegistrationExpectedReviewTime} />
                </ListItem>
                <ListItem>
                    <LocalizedText
                        textKey={TextKey.SmsUsaRegistrationAssociatedCosts}
                        substitutes={{
                            brandRegistrationCost: brandRegistrationCostText,
                            campaignRegistrationCost: campaignRegistrationCostText,
                        }}
                    />
                </ListItem>
                <ListItem>
                    <LocalizedText textKey={TextKey.SmsUsaRegistrationCompletedSMSCampaignStartsAutomatically} />
                </ListItem>
            </SimpleList>
        </Stack>
    );
};

const ListItem: React.FC<WithChildren> = ({ children }) => (
    <SimpleListItem>
        <Typography textStyle="bodyMedium" as="span">
            {children}
        </Typography>
    </SimpleListItem>
);
